import { createApiQueryOptions } from './createApiQueryOptions';
import { useApisClientContext, useQueryOptionsContext } from '../Providers';
import { getSharedQueryClient } from './queryClientInstance';
import { mergeQueryOptions } from './internal';
import React from 'react';
export const createApiQuery = _ref => {
  let {
    methodConfig
  } = _ref;
  const queryOptionsBuilder = createApiQueryOptions({
    methodConfig
  });
  return async args => {
    const {
      httpClient,
      request,
      options
    } = args;
    const queryClient = getSharedQueryClient();
    const queryOptions = queryOptionsBuilder({
      httpClient,
      request,
      options
    });
    return queryClient.fetchQuery({
      ...queryOptions
    });
  };
};
export const createApiQueries = _ref2 => {
  let {
    apiConfig
  } = _ref2;
  return Object.keys(apiConfig).reduce((acc, methodName) => {
    const methodConfig = apiConfig[methodName];
    const fetchFn = createApiQuery({
      methodConfig
    });
    return {
      ...acc,
      [methodName]: fetchFn
    };
  }, {});
};
export const createApiQueriesClient = _ref3 => {
  let {
    apiConfig,
    apiQueries
  } = _ref3;
  return _ref4 => {
    let {
      httpClient,
      context
    } = _ref4;
    return Object.keys(apiConfig).reduce((acc, methodName) => ({
      ...acc,
      [methodName]: (request, options) => apiQueries[methodName]({
        request,
        options: mergeQueryOptions(context, options),
        httpClient
      })
    }), {});
  };
};
export const createApiUseQueries = _ref5 => {
  let {
    apiQueries
  } = _ref5;
  return context => {
    const {
      httpClient
    } = useApisClientContext();
    const {
      queryOptions: contextOptions,
      hooksOnly
    } = useQueryOptionsContext();
    return React.useMemo(() => Object.keys(apiQueries).reduce((acc, methodName) => ({
      ...acc,
      [methodName]: (request, options) => {
        const {
          ignoreQueryContext,
          ...context_
        } = context != null ? context : {};
        return apiQueries[methodName]({
          httpClient,
          request,
          options: mergeQueryOptions(hooksOnly || ignoreQueryContext ? {} : contextOptions, context_, options)
        });
      }
    }), {}), [hooksOnly, contextOptions, context]);
  };
};
//# sourceMappingURL=createApiQuery.js.map